import React from "react";

export const Button = ({ onClick, disabled, style, children }) => {
  return (
    <button
      style={{ fontSize: "2rem", lineHeight: 1, ...style }}
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </button>
  );
};
